module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/aleksandra-maslankiewicz-ccc0a1013b5854c9b0c2e81a8d702ae4.png";